import React from "react"
import { FormField } from "src/features/calculator/components/field/FormField"
import styled from "styled-components"
import { FieldErrors, UseFormSetValue } from "react-hook-form"
import { CalculationSchema } from "src/features/calculator/schema"

type Props = {
  customerTransferFee: number
  rent: number
  customerTransferFeeRate: number
  setValue: UseFormSetValue<CalculationSchema>
  errors: FieldErrors<CalculationSchema>
}

export function CustomerTransferFeeRow({
  customerTransferFee,
  rent,
  customerTransferFeeRate,
  setValue,
  errors,
}: Props) {
  return (
    <StyledCalculatorRowDiv>
      <FormField
        label="送客手数料(税込)"
        type="number"
        placeholder="Placeholder"
        hint={`${customerTransferFee.toLocaleString()}円`}
        disabled
        value={customerTransferFee}
      />
      <span>= round (</span>
      <FormField
        label="家賃"
        type="number"
        placeholder="Placeholder"
        hint={`${rent.toLocaleString()}円`}
        onChange={(e) => {
          setValue("rent", Number(e.target.value))
        }}
        errorText={errors?.rent?.message}
        value={rent}
      />
      <span>x</span>
      <FormField
        label="送客手数料率(税込)"
        type="number"
        placeholder="Placeholder"
        hint={`${customerTransferFeeRate}%`}
        onChange={(e) => {
          setValue("customerTransferFeeRate", Number(e.target.value))
        }}
        errorText={errors?.customerTransferFeeRate?.message}
        value={customerTransferFeeRate}
      />
      <span>)</span>
    </StyledCalculatorRowDiv>
  )
}

const StyledCalculatorRowDiv = styled("div")`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
`
